import { User, Todo, AlertContent } from '../models'
export { Subscription, Api, TokenName, Observable, of, Store, Todo, User, AlertContent } from '../models'

export enum AppFields {
  App = 'app',
  User = 'user',
  Token = 'token',
  Loading = 'loading',
  Alert = 'alert'
}

export interface AppState {
  user: User,
  loading: string,
  todos: Todo[],
  alert: AlertContent
}

export const InitialState: AppState = {
  user: null,
  loading: null,
  todos: [],
  alert: null
}

export interface State { app: AppState }

export enum Types {
  initialize = 'initialize',
  UpdateState = 'update-app-state',
  initializeFailed = 'initialize-failed',
  logIn = 'log-in',
  logInSuccess = 'log-in-success',
  logInFailed = 'log-in-failed',
  logOut = 'log-out',
  logOutSuccess = 'log-out-success',
  register = 'register',
  registerSuccess = 'register-success',
  registerFailed = 'register-failed',
  getTodos = 'get-todos',
  getTodosSuccess = 'get-todos-success',
  serverError = 'server-error',
  LogOut = 'log-out',
  ImportedItem = 'imported-item'
}

export const AppTypes = Types

// actions
export interface UpdateState { type: Types.UpdateState, payload: any }
export interface InitializeFailed { type: Types.initializeFailed }
export interface LogIn { type: Types.logIn, payload: { email: string, password: string, tenantSlug?: string }}
export interface LogInFailed { type: Types.logInFailed }
export interface LogOut { type: Types.logOut }
export interface LogOutSuccess { type: Types.logOutSuccess }
export interface Register { type: Types.register, payload: User }
export interface RegisterFailed { type: Types.registerFailed }
export interface GetTodos { type: Types.getTodos }
export interface GetTodosSuccess { type: Types.getTodosSuccess, payload: { todos: Todo[] }}
export interface ServerError { type: Types.serverError, payload: any }
export interface LogOut { type: Types.LogOut }
export interface ImportedItem { type: Types.ImportedItem, payload: any }

export type Action =
  InitializeFailed | LogIn | LogInFailed | LogOut | LogOutSuccess | UpdateState | Register |
  RegisterFailed | GetTodos | GetTodosSuccess | ServerError | LogOut | ImportedItem



// WEBPACK FOOTER //
// ./src/app/store/app.model.ts